'use client';
import { isNumber } from '@s7/utils';

var getLineClamp = function(lineClamp) {
    if (isNumber(lineClamp)) {
        return {
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: lineClamp,
            WebkitBoxOrient: "vertical"
        };
    }
    return undefined;
};

export { getLineClamp };
